import { useFormikContext } from "formik";
import padStart from "lodash/padStart";
import { ICharterRequest } from "../../Models/ICharterRequest";

const FlightTimeSummary = () => {
    const { values } = useFormikContext<ICharterRequest>();
    const totalFlightTime = values.routes.map(r => {
        const raw = (r.flightTime ?? "").trim();
        if (!raw) return 0;
        const parts = raw.split(':');
        const hours = parseInt(parts[0]) || 0;
        const minutes = parts.length > 1 ? (parseInt(parts[1]) || 0) : 0;
        return hours * 60 + minutes;
    }).reduce((acc, mins) => acc + mins, 0);
    return <><b>Total flight time:</b> {`${padStart(`${Math.floor(totalFlightTime / 60)}`, 2, '0')
        }:${padStart(`${totalFlightTime % 60}`, 2, '0')}`}<br /></>
}

export default FlightTimeSummary;